export const queryKeyFactory = {
  listPatients: (clinicId: string, pendingUsers: boolean) => [
    'listPatients',
    'clinic',
    clinicId,
    'pendingUsers',
    pendingUsers
  ],
  listClinicians: (clinicId: string, pendingUsers: boolean) => [
    'listClinicians',
    'clinic',
    clinicId,
    'pendingUsers',
    pendingUsers
  ],
  listPatientsWithAssessmentStatus: (
    clinicId: string,
    pendingUsers: boolean
  ) => [
    'listPatientsWithAssessmentStatus',
    'clinic',
    clinicId,
    'pendingUsers',
    pendingUsers
  ],
  cgs: (patientId: string) => ['assessments', patientId, 'cgs'],
  pcs: (patientId: string) => ['assessments', patientId, 'pcs'],
  dhi: (patientId: string) => ['assessments', patientId, 'dhi'],
  promis: (patientId: string) => ['assessments', patientId, 'promis'],
  impact: (patientId: string) => ['assessments', patientId, 'impact'],
  concussions: (patientId: string) => [patientId, 'concussions'],
  invitation: {
    root: () => ['invitation'],
    link: (invitationId: string) => [
      ...queryKeyFactory.invitation.root(),
      invitationId,
      'link'
    ]
  },
  assessment: {
    list: (patientId: string) => ['assessment', 'list', patientId],
    pending: (patientId: string) => ['assessment', 'pending', patientId],
    overview: (patientId: string) => ['assessment', 'overview', patientId]
  },
  onboarding: (patientId: string) => ['onboarding', patientId],
  clinician: {
    data: (clinicianId: string) => ['clinician', 'data', clinicianId],
    clinicAdminData: (uid: string) => ['clinicAdminData', uid]
  },
  clinic: {
    __root__: (clinicId: string) => ['clinic', clinicId],
    balance: {
      __root__: (clinicId: string) => [
        ...queryKeyFactory.clinic.__root__(clinicId),
        'balance'
      ],
      aggregateHistory: (clinicId: string) => [
        ...queryKeyFactory.clinic.balance.__root__(clinicId),
        'aggregateHistory'
      ]
    },
    billing: {
      __root__: (clinicId: string) => [
        ...queryKeyFactory.clinic.__root__(clinicId),
        'billing'
      ],
      hasPaymentMethod: (clinicId: string) => [
        ...queryKeyFactory.clinic.billing.__root__(clinicId),
        'hasPaymentMethod'
      ],
      hasSubscription: (clinicId: string) => [...queryKeyFactory.clinic.billing.__root__(clinicId), 'hasSubscription'],
      getInvoice: (clinicId: string, invoiceId: string) => [
        ...queryKeyFactory.clinic.billing.__root__(clinicId),
        'getInvoice',
        invoiceId
      ],
      getAllProducts: (clinicId: string) => [
        ...queryKeyFactory.clinic.billing.__root__(clinicId),
        'getAllProducts'
      ]
    },
    basicInfo: (clinicId: string) => [
      ...queryKeyFactory.clinic.__root__(clinicId),
      'basicInfo'
    ],
    principalUser: (clinicId: string) => [
      ...queryKeyFactory.clinic.__root__(clinicId),
      'principalUser'
    ],
    allInfo: (clinicId: string) => [
      ...queryKeyFactory.clinic.__root__(clinicId),
      'allInfo'
    ],
    productOptions: (clinicId: string) => [
      ...queryKeyFactory.clinic.__root__(clinicId),
      'productOptions'
    ],
    onboarding: {
      validate: (token: string) => ['onboardingTokenValidation', token]
    },
    assessmentBalance: (clinicId: string, assessmentType: string) => [
      ...queryKeyFactory.clinic.__root__(clinicId),
      'assessmentBalance',
      assessmentType
    ]
  },
  patient: {
    impactProfile: (patientId: string) => [
      ...queryKeyFactory.patient.rootSingle(patientId),
      'impactProfile'
    ],
    root: () => ['patient'],
    rootSingle: (patientId: string) => [
      ...queryKeyFactory.patient.root(),
      patientId
    ],
    loginLink: {
      root: (patientId: string) => [
        ...queryKeyFactory.patient.rootSingle(patientId),
        'loginLink'
      ],
      list: (patientId: string) => [
        ...queryKeyFactory.patient.loginLink.root(patientId),
        'list'
      ],
      token: (assessmentLinkId: string) => [
        ...queryKeyFactory.patient.loginLink.root('--'),
        'loginLink',
        assessmentLinkId
      ]
    }
  },
  integration: {
    root: () => ['root'],
    impact: {
      root: () => [...queryKeyFactory.integration.root(), 'impact'],
      isTokenValid: (token: string) => [
        ...queryKeyFactory.integration.impact.root(),
        'isTokenValid',
        token
      ],
      isInPilot: (id: string) => [
        ...queryKeyFactory.integration.impact.root(),
        'isInPilot',
        id
      ],
      decodedToken: (token: string) => [
        ...queryKeyFactory.integration.impact.root(),
        'decodedToken',
        token
      ],
      isAssignedToPatientWithPassportId: (passportId: string) => [
        ...queryKeyFactory.integration.impact.root(),
        'passportidassignment',
        passportId
      ],
      toOnboarding: (impactOrganisationId: string, domain: string, locationCode: string, passportID: string) => [
        ...queryKeyFactory.integration.impact.root(),
        'toOnboarding',
        impactOrganisationId,
        domain,
        locationCode,
        passportID
      ]
    }
  },
  billingSettings: {
    root: () => ['billingSettings'],
    details: () => [...queryKeyFactory.billingSettings.root(), 'details']
  }
};
